<template>
<v-dialog width="500" v-model="showProfile">
  <v-card>
    <v-card-title>
      <span class="headline">Profil používateľa</span>
    </v-card-title>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs12>
            <v-text-field v-model="emailaddress" label="E-mail" required></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field v-model="phone" label="Telefón" required></v-text-field>
          </v-flex>
          <v-card-title>
            <span class="subheading">Notifikácie</span>
          </v-card-title>
          <v-flex xs12>
            <v-checkbox v-model="sms" label="SMS"></v-checkbox>
            <v-checkbox v-model="email" label="E-mail"></v-checkbox>
          </v-flex>
        </v-layout>
      </v-container>
      <small>*povinné pole</small>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" flat @click="showHideProfile()">Close</v-btn>
      <v-btn color="blue darken-1" flat @click="showHideProfile();saveChanges()">Save</v-btn>
    </v-card-actions>
  </v-card>
  </v-dialog>
</template>

<script>
import { HTTP } from '../common/http'

export default {
  name: 'Profile',
  props: ['showProfile'],
  data() {
    return {
      sms: false,
      email: false,
      emailaddress: '',
      phone: ''
    }
  },
  mounted() {
    HTTP.get('/admin', {
        params: {
          id: localStorage.id
        }
      }).then(response => {
        this.emailaddress = response.data.email
        this.phone = response.data.phone
        this.sms = response.data.notifications.includes('sms')
        this.email = response.data.notifications.includes('email')
      })
  },
  methods: {
    editLayer: function (id) {
      this.$emit('getLayerInfo', id)
    },
    saveChanges: function () {
      let notifications = []
      if (this.sms) notifications.push('sms')
      if (this.email) notifications.push('email')
      HTTP.put('/admin', {
        id: localStorage.id,
        email: this.emailaddress,
        phone: this.phone,
        notifications: notifications
      }).then()
      .catch(err => console.error(err))
    },
    showHideProfile: function () {
      let show = this.showProfile
      show = false
      this.$emit('show-hide-profile', show)
    }
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Profile.vue